import { useMemo } from "react";
import roundCustom from "../../Utils/RoundCustom";

export default function useTotaisBaixa(titulos, pagamentos) {

  const totais = useMemo(() => {
    var t = {
      bruto: roundCustom(titulos?.reduce((a, b) => a + b.valor, 0)),
      desconto: roundCustom(titulos?.reduce((a, b) => a + b.desconto, 0)),
      juros: roundCustom(titulos?.reduce((a, b) => a + b.juros, 0))
    };

    t.liquido = roundCustom(t.bruto - t.desconto + t.juros);

    return t;

  }, [titulos]);

  const totaisPgto = useMemo(() => {
    if (!pagamentos)
      return {};

    var total = roundCustom(pagamentos.reduce((a, b) => a + b.recebido, 0));
    return {
      total,
      troco: total <= totais.liquido ? 0 : roundCustom(-(totais.liquido - total))
    };

  }, [pagamentos]);


  return { ...totais, ...totaisPgto };
}